export function readReplayLink(search) {
  const params = new URLSearchParams(search);
  const id = params.get('replayId');
  const at = params.get('at');
  if (!id || !/^[1-9]\d*$/.test(id) || !Number.isSafeInteger(Number(id))) return null;
  if (at !== null && (!/^\d+$/.test(at) || !Number.isFinite(new Date(Number(at)).getTime()))) return null;
  return { replayId: Number(id), timestamp: at === null ? null : Number(at) };
}

export function createReplayLink(href, replayId, timestamp) {
  const url = new URL('/User/admin/replays', href);
  url.searchParams.set('replayId', String(replayId));
  url.searchParams.set('at', String(Math.round(timestamp)));
  return url.href;
}
